import { MERCH_CARD } from 'pricing-pages-lib/constants/PurchaseMotionsLocations';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getIsAdmin } from 'ui-addon-upgrades/_core/common/eligibility/getIsAdmin';
import { ASSIGN_SEAT, BUY_ADDITIONAL_SEATS, REQUEST_SEAT, VIEW_ACCOUNT } from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
import { allPurchaseMotionsSelector } from '../../selectors/PurchaseMotionSelectors';

const overrideSeatPurchaseMotions = (purchaseMotions, isAdmin) => {
  // Not seats scenario, so use MERCH_CARD purchase motions
  if (!purchaseMotions.includes(VIEW_ACCOUNT) && !purchaseMotions.includes(BUY_ADDITIONAL_SEATS)) {
    return purchaseMotions;
  } // Seats scenario, so override purchase motions


  if (isAdmin) {
    return [ASSIGN_SEAT];
  } else {
    return [REQUEST_SEAT];
  }
};
/*
Temporary solution:
MERCH_CARD location returns viewAccount and buyAdditionalSeats in seats scenarios.
We need to switch these to requestSeat or assignSeat.
*/


const GetPersonalizedPPPurchaseMotions = upgradePointApiName => {
  const [isAdmin, setIsAdmin] = useState();
  useEffect(() => {
    getIsAdmin().then(setIsAdmin).catch(() => setIsAdmin(false));
  }, []);
  const purchaseMotions = useSelector(state => {
    const allPurchaseMotions = allPurchaseMotionsSelector(state);
    const merchCardPurchaseMotions = allPurchaseMotions[MERCH_CARD];
    const upgradePointPurchaseMotions = merchCardPurchaseMotions.purchaseMotions[upgradePointApiName];
    return upgradePointPurchaseMotions ? upgradePointPurchaseMotions.map(({
      key
    }) => key) : [];
  });

  if (!purchaseMotions || !purchaseMotions.length || isAdmin === undefined) {
    return [];
  } else {
    return overrideSeatPurchaseMotions(purchaseMotions, isAdmin);
  }
};

export default GetPersonalizedPPPurchaseMotions;